module.exports = __webpack_public_path__ + "img/logo-dark.3379f12.svg";